import React from 'react'

export const Studentpanal = () => {
  return (
    <div>Studentpanal</div>
  )
}
